import {
  Button,
  OutlinedSelect,
  SearchAccordion,
  SearchBox,
  SelectOptionType,
  useMobile,
} from '@octano/global-ui';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Form, Row } from 'reactstrap';

import { TranslationsKeys } from '../../../../locales/translations';
import { useSearchFiltersLoaderData } from '../hooks/SearchFiltersLoader';
import { CreateButton } from './CreateButton';

export type Filters = {
  name: string | null;
  code: string | null;
  school: SelectOptionType | null;
  modality: SelectOptionType | null;
};

const DEFAULT_VALUES = {
  name: null,
  code: null,
  school: null,
  modality: null,
};

interface SearchFiltersProps {
  onFiltersChange: (filterValues: Filters) => void;
}

export function SearchFilters({
  onFiltersChange = () => null,
}: SearchFiltersProps) {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_STUDY_PLANS,
  );
  const prefix = 'searchFilters';
  const isMobile = useMobile();

  // Obtener datos del loader
  const { ...formData } = useSearchFiltersLoaderData();
  const schools = formData?.schools ?? [];
  const modalities = formData?.modalities ?? [];

  const { handleSubmit, control, reset } = useForm<Filters>({
    defaultValues: DEFAULT_VALUES,
    mode: 'onChange',
  });

  const cleanValues = () => {
    reset();
    onFiltersChange(DEFAULT_VALUES);
  };

  const onSubmit = useCallback(
    async (values: Filters) => {
      onFiltersChange(values);
    },
    [onFiltersChange],
  );

  return (
    <div className="pb-4 pb-lg-1">
      <SearchAccordion btnText={t(`${prefix}.title`)}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="gutters-filterss">
            <Col xs={12} md={6} lg={3}>
              <SearchBox
                name="name"
                label={t(`${prefix}.name`)}
                placeholder={t(`${prefix}.namePlaceholder`)}
                control={control}
              />
            </Col>
            <Col xs={12} md={6} lg={3}>
              <SearchBox
                name="code"
                label={t(`${prefix}.code`)}
                placeholder={t(`${prefix}.codePlaceholder`)}
                control={control}
              />
            </Col>

            <Col xs={12} md={6} lg={3}>
              <OutlinedSelect
                name="school"
                options={schools}
                label={t(`${prefix}.school`)}
                control={control}
              />
            </Col>
            <Col xs={12} md={6} lg={3}>
              <OutlinedSelect
                name="modality"
                options={modalities}
                label={t(`${prefix}.modality`)}
                control={control}
              />
            </Col>
            <Col xs={12} md={6} lg={3} className="offset-md-9 offset-lg-9">
              <Row
                className="gutters-filters"
                style={{ marginTop: isMobile ? 0 : '1.5rem' }}
              >
                <Col>
                  <Button
                    type="submit"
                    text={t(`common.actions.search`)}
                    size="md"
                    fullwidth
                  />
                </Col>
                <Col>
                  <Button
                    text={t(`common.actions.clean`)}
                    size="md"
                    outlined
                    onClick={cleanValues}
                    fullwidth
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
        <CreateButton />
      </SearchAccordion>
    </div>
  );
}
